var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// icons
import PlanePaper from "@frameworks/shared-library/assets/images/features/Markets/Pms/plane-paper.png";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/redirection.scss";
var Redirection = function () {
    //
    var _a = __read(useState(10), 2), timeLeft = _a[0], setTimeLeft = _a[1];
    var orderData = useSelector(function (state) { return state.markets.AifPms; }).orderData;
    useEffect(function () {
        window.open(orderData === null || orderData === void 0 ? void 0 : orderData.issuer_redirection_url, "_blank");
        var timer = setInterval(function () {
            setTimeLeft(function (prevTime) {
                if (prevTime <= 1) {
                    clearInterval(timer);
                }
                return prevTime - 1;
            });
        }, 1000);
        return function () { return clearInterval(timer); };
    }, []);
    return (React.createElement("div", { className: "redirection-container" },
        React.createElement("div", { className: "redirection-great-start" },
            React.createElement("img", { src: PlanePaper, alt: "PlanePaper" }),
            React.createElement("h4", { className: "DMSans_16_500" }, "Great start, You've recorded the client's transaction on Nuvama Wealth.")),
        React.createElement("div", { className: "redirection-carnelian-box" },
            React.createElement("div", { className: "redirection-carnelian-inner" },
                React.createElement("p", { className: "DMSanM_14_500" },
                    React.createElement("span", null, "Next step:"),
                    " Update details on ", orderData === null || orderData === void 0 ? void 0 :
                    orderData.issuer_name),
                React.createElement("img", { src: orderData === null || orderData === void 0 ? void 0 : orderData.issuer_logo_url, alt: orderData === null || orderData === void 0 ? void 0 : orderData.issuer_name }),
                React.createElement("div", { className: "redirection-carnelian-links" },
                    React.createElement("p", { className: "DMSansNormal_12_400" }, "Redirecting to the manufacturer's website..."),
                    React.createElement("p", { className: "DMSansNormal_12_400" },
                        "If not redirected in ",
                        timeLeft,
                        " seconds,",
                        " ",
                        React.createElement("a", { className: "", href: orderData === null || orderData === void 0 ? void 0 : orderData.issuer_redirection_url, target: "_blank" }, "click here."))))),
        React.createElement("div", { className: "info-box" },
            React.createElement("i", { className: "edel-icon-Information text-independence" }),
            React.createElement("h5", { className: "DMSans_13_400" }, "Once done, Track order status on orderbook."))));
};
export default Redirection;
